export const intro = (
  <p>
    Szybkie pytania to specjalna sekcja portalu medycznego, zaprojektowana z
    myślą o medykach i studentach, którzy na co dzień stają przed wieloma
    decyzjami diagnostycznymi i terapeutycznymi. Sekcja odpowiada na najczęstsze
    i najbardziej praktyczne pytania kliniczne, wspierając podejmowanie trafnych
    decyzji w czasie rzeczywistym – w gabinecie, na dyżurze czy podczas
    konsultacji.
  </p>
);

export const content = (
  <>
    <h3>Dlaczego warto?</h3>
    <p>
      Nie każde pytanie wymaga przeszukiwania obszernych wytycznych czy
      podręczników. Czasem wystarczy konkretna, aktualna i praktyczna odpowiedź,
      np.:
    </p>
    <ul>
      <li>„Czy każdy pacjent z podwyższonym TSH wymaga leczenia?”</li>
      <li>„Kiedy należy skierować pacjenta na operację bariatryczną?”</li>
      <li>„Czy dorośli powinni się szczepić przeciwko meningokokom?”</li>
    </ul>
    <p>
      Dzięki sekcji „Szybkie pytania” użytkownik uzyskuje błyskawiczny dostęp do
      wiedzy opartej na najnowszych rekomendacjach i doświadczeniu klinicznym.
    </p>
    <h3>Co znajdziesz w sekcji?</h3>
    <ul>
      <li>Zwięzłe odpowiedzi na najczęstsze pytania.</li>
      <li>Przykłady z życia wzięte i dylematy spotykane w praktyce.</li>
      <li>Treści aktualizowane na podstawie zaleceń towarzystw naukowych.</li>
      <li>Wygodny podział na specjalizacje i intuicyjną nawigację.</li>
      <li>Powiązanie z innymi narzędziami – ICD-10, leki, algorytmy.</li>
    </ul>
    <p>
      Sekcja <strong>„Szybkie pytania”</strong> to praktyczne wsparcie w
      codziennej pracy lekarza. Pozwala szybko zweryfikować decyzje, sprawdzić
      aktualne zalecenia i działać zgodnie z obowiązującymi standardami – zawsze
      wtedy, gdy liczy się czas i precyzja.
    </p>
  </>
);

export const fastQuestionDescription = { intro, content };
